import type { TRiskFrequencyWithNA } from "./Risk";


export class Hazard {
    hazard_id: string = "";
    label: string = "";
    description: string = "";
    likelihood: TRiskFrequencyWithNA = "n/a";

    constructor(init?: Partial<Hazard>) {
        Object.assign(this, init);
    }

}

